module.exports = {"430972005":"朝阳街道","430972006":"东部产业园地区","430972109":"谢林港镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430972.json
// module id = 2015
// module chunks = 0